import router from '@/router/index'
// import store from '@/store/index'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { SetToken, GetToken } from '@/utils/auth'
import axios from 'axios'
// import config from '@/components/Config'
import { omit } from 'lodash'

NProgress.configure({ showSpinner: false })

// const ssoUrl = config.ssoUrl
// const siteUrl = config.siteUrl
let flag = true
router.beforeEach((to, from, next) => {
  if (to.meta) {
    document.title = to.meta.title
  }
  // debugger
  if (to.query !== undefined && to.query.token !== undefined) {
    // debugger
    // 校验Token
    // 校验成功返回xAccessToken
    SetToken(to.query.token).then(() => {
      // debugger
      if (GetToken()) {
        const params = omit(to.query, 'token')
        router.replace({ path: to.path, query: params })
        next()
        if (flag) {
          flag = false
          // const roles = null
          // 设置X-Access-Token为query传过来的token
          axios.defaults.headers['X-Access-Token'] = GetToken()
          /*
          store.dispatch('GenerateRoutes', { roles }).then((accessRoutes) => {
            // 根据roles权限生成可访问的路由表
            // //debugger
            accessRoutes.forEach((route) => {
              router.addRoute(route) // 动态添加可访问路由表
            })
            next({ ...to, replace: true }) // hack方法 确保addRoutes已完成
          })
          */
        }
      } else {
        // 不做登录控制
        // location.href = ssoUrl + '/login?url=' + siteUrl
        next()
      }
    })
  } else if (GetToken()) {
    next()
    if (flag) {
      flag = false
      /*
      const roles = null
      store.dispatch('GenerateRoutes', { roles }).then((accessRoutes) => {
        // 根据roles权限生成可访问的路由表
        // //debugger
        accessRoutes.forEach((route) => {
          try {
            router.addRoute(route) // 动态添加可访问路由表
          } catch (err) {
            console.log(err, 'err')
          }
        })
        next({ ...to, replace: true }) // hack方法 确保addRoutes已完成
      })
      */
    }
  } else {
    if (!GetToken()) {
      // 不做登录控制
      // location.href = ssoUrl + '/login?url=' + siteUrl
      next()
    } else {
      next()
    }
  }
})

router.afterEach((to, from) => {
  console.log('(to.path===>', to.path)
  // if (to.path.includes('hundredDaysPlan/view/')) {
  // router.push(to.path + '?t=' + new Date().getTime())
  // }

  NProgress.done()
})
